export const REVIEW_OF_SPOWER_TAGS = {
  WORK: {
    POSITIVE: {
      HIGH_QUALITY: {
        key: 'high_quality',
        text: '仕事が丁寧だった'
      },
      QUICK_REVISIT: {
        key: 'quick_revisit',
        text: '再訪問の対応が早い'
      },
      EFFICIENT: {
        key: 'efficient',
        text: '仕事のスピードが早い'
      },
      GOOD_COMMUNICATION: {
        key: 'good_communication',
        text: '円滑なコミュニケーション'
      }
    },
    NEGATIVE: {
      POOR_COMMUNICATION: {
        key: 'poor_communication',
        text: 'コミュニケーション不足'
      },
      UNPROFESSIONAL: {
        key: 'unprofessional',
        text: 'プロとして不適切な言動'
      },
      INSTRUCTION_VIOLATION: {
        key: 'instruction_violation',
        text: '注意事項を守らなかった'
      },
      WORK_MISMATCH: {
        key: 'work_mismatch',
        text: '伝えていた業務内容と違う'
      }
    }
  },
  CHARACTER: {
    POSITIVE: {
      ENERGETIC: {
        key: 'energetic',
        text: '元気がある'
      },
      POLITE: {
        key: 'polite',
        text: '礼儀正しい'
      },
      PUNCTUAL: {
        key: 'punctual',
        text: '時間を守る'
      },
      FLEXIBLE: {
        key: 'flexible',
        text: '臨機応変'
      },
      WELL_GROOMED: {
        key: 'well_groomed',
        text: '適切な身だしなみ'
      }
    },
    NEGATIVE: {
      NOT_CHEERFUL: {
        key: 'not_cheerful',
        text: '明るくない'
      },
      POOR_MANNERS: {
        key: 'poor_manners',
        text: '礼儀に問題がある'
      },
      NOT_PUNCTUAL: {
        key: 'not_punctual',
        text: '時間を守れない'
      },
      POOR_COOPERATION: {
        key: 'poor_cooperation',
        text: '協調性にかける'
      },
      POOR_GROOMING: {
        key: 'poor_grooming',
        text: '清潔感がない'
      }
    }
  }
}
